import http from '@/utils/http'
import { ParamObject, TranslateAllLangReq, TranslateReq } from '@/model'

export default ParamObject

export const getFeedDetail = (p: object) => http.post('detail', 'feed/feed', p);

export const getComment = (p: object) => http.post('list', 'comment/comment', p);

export const getTopicFeedList = (p: any) => http.post(`topicfeedlist`, 'feed', p, {}, {openid: p.openid});

// 上报接口
export const reportSend = (p: object) => http.post('send', 'qapm/report', p);
